import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import DoseSpotErrorModalStyle from "../../styles/doseSpotErrorModalStyle";


class DoseSpotErrorModal extends React.Component {
    render() {
        let { classes, isDoseSpotErrorModalOpen, closeModal } = this.props;
        return (
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                onClose={closeModal}
                open={isDoseSpotErrorModalOpen}
                style={{ zIndex: 130 }}
                closeAfterTransition
                BackdropComponent={() => <Backdrop style={{ visibility: "visible" }} />}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={isDoseSpotErrorModalOpen}>
                    <div data-app="dosespot-error-modal-component-wrapper" className={classes.modalWrapper}>
                        <div className={classes.modalHeader}>DoseSpot Jumpstart Error</div>
                        <div className={classes.modalBody}>
                            <div className={`${classes.contentWrapper}`}>
                                {isDoseSpotErrorModalOpen}
                                <span className={classes.spanText}>This order has been updated to Pending Support, Tech Support has been notified and will contact you when ready to complete.</span>
                            </div>
                            <Button
                                onClick={closeModal}
                                variant="contained"
                                color="primary"
                                className={classes.buttonStyle}
                            >
                                OK
                            </Button>
                        </div>
                    </div>
                </Fade>
            </Modal>
        )
    }
}


export default withStyles(DoseSpotErrorModalStyle)(DoseSpotErrorModal);

